import React from "react";
import Card from "components/card/Card";
import Table from "components/table/Table";
import { trxnsFields } from "../../../models/data";
import { formatYMD, formatDMY } from "views/helpers/date";

export default function TransactionTable({
  isLoading = false,
  reportDate = null,
  filter = false,
  setReportDate = null,
  setFilterState = null,
  trxns = null,
  nDays = 1,
}) {
  const setReportFilter = (date) => {
    setReportDate(formatDMY(date));
  };

  const showFilterHandler = (e) => {
    setFilterState(e.target.checked);
  };

  const dateSub = (date, n) => {
    let tmpDate = new Date(Date.parse(formatYMD(date)));
    tmpDate = new Date(
      tmpDate.setDate(tmpDate.getDate() - n)
    ).toLocaleDateString("en-GB", { timeZone: "Africa/Lagos" });
    return formatYMD(tmpDate);
  };

  const tableProps = {
    ...trxnsFields,
    data: trxns,
    useBasicTemplate: false,
    toolbarIsVisible: true,
    pagingIsAllowed: true,
    fontSize: 12,
    pageSize: 10,
    loading: isLoading,
    minDateVal: dateSub(reportDate),
    dateVal: formatYMD(reportDate),
    maxDateVal: formatYMD(
      new Date().toLocaleDateString("en-GB", { timeZone: "Africa/Lagos" })
    ),
    setReportFilter,
    showFilterHandler,
    showFilter: filter,
    disableDateFilter: false,
    disableFilter: false,
    filename: "Transactions",
  };

  return (
    <Card
      w="100%"
      px="15px"
      py="15px"
      overflowX={{ sm: "scroll", lg: "hidden" }}
    >
      <Table {...tableProps} />
    </Card>
  );
}
